import { createContext, ReactNode, useContext, useMemo } from 'react';

import { getFormTheme } from '../../utilities/getFormTheme';

type FormThemeContextType = {
  backgroundColor: string;
  primaryTextColor: string;
  secondaryTextColor: string;
};

interface FormThemeContextProps {
  theme: string;
  children: ReactNode;
}

export const FormThemeContext = createContext<FormThemeContextType>(getFormTheme());

export const useFormTheme = () => {
  return useContext(FormThemeContext);
};

export const FormThemeProvider = ({ theme, children }: FormThemeContextProps) => {
  const memoizedTheme = useMemo(() => {
    return getFormTheme(theme);
  }, [theme]);

  return <FormThemeContext.Provider value={memoizedTheme}>{children}</FormThemeContext.Provider>;
};
